// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"173":"lg-3","558":"lg-8","2018":"lg-2","2453":"lg-11","2478":"lg-6","3321":"lg-12","3388":"lg-1","3637":"lg-5","3730":"lg-9","3963":"lg-0","4441":"lg-10","6440":"lg-4","9868":"lg-7"}[chunkId] || chunkId) + ".js";
};